import { Progress } from "../../common/entities/Progress"

const isNoInterviewSelected = (interviews: Progress[], includes: string) => {
  return interviews.filter((i) => i.mediaId.includes(includes)).length === 0
}

export default isNoInterviewSelected
